var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7e26eca79a07e06eb9358049a66912f7511d3197"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["digital-spiders-website@digital-spiders"]={id:"7e26eca79a07e06eb9358049a66912f7511d3197"};
      